import React from 'react';
import classNames from 'classnames';
import SectionComponent from '../Section';
import Field from '../../../Models/Field';
import Utils from '../../../Services/Utils';
import CustomSectionComponent from '../CustomSection';
import FieldList from '../../../Models/FieldList';

import {
  STATUS_PENDING,
  STATUS_APPROVAL_RETURN_TO_SUBMITTER,
  STATUS_APPROVAL_IN_PROGRESS
} from '../../../Services/api/ActionItems';
import $ from '../../../../offline/jquery.min';
import ConfigService from '../../../Services/api/Config';

class LfaCustomForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSecondSection: false,
      sectionsHidden: []
    };
    this.rowRef = React.createRef();
  }

  componentDidMount() {
    const { fieldsData } = this.props;
    this.setState({
      showSecondSection: !Utils.isEmpty(fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value)
    });
    setTimeout(this.setTotalResidents, 100);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { fieldsData } = this.props;
    const { showSecondSection } = this.state;
    const prevShowSecondSection = !Utils.isEmpty(prevProps.fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value);
    const newShowSecondSection = !Utils.isEmpty(fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value);
    if (
      prevShowSecondSection !== newShowSecondSection ||
      (showSecondSection === prevState.showSecondSection && showSecondSection !== newShowSecondSection)
    ) {
      this.setState({ showSecondSection: newShowSecondSection });
    }
  }

  toggleSecondSection = () => {
    const { showSecondSection } = this.state;
    const { fieldsData, api, status, configuration } = this.props;
    if (![STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(status)) return;
    let modified = false;
    for (const fieldID of configuration.sections.items['sectiondivider'].fields.order) {
      if (!Utils.isEmpty(fieldsData.sections['sectiondivider'].fields[fieldID].value)) {
        modified = true;
      }
    }
    if (Utils.isEmpty(fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value)) {
      fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value = '0';
      api.onFieldValueChange('sectiondivider#8', 'checkbox#15', '0');
    } else if (showSecondSection && fieldsData.sections['sectiondivider#10'].fields['numberinput#41'].value === 2 && !modified) {
      fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value = undefined;
      api.onFieldValueChange('sectiondivider#8', 'checkbox#15', undefined);
      setTimeout(this.setTotalResidents, 100);
    }
    this.setState({ showSecondSection: !showSecondSection });
  };

  sectionsHiddenList = (sectionId) => {
    const { sectionsHidden } = this.state;
    return sectionsHidden.indexOf(sectionId) < 0;
  };

  showSectionHidden = (sectionId) => {
    const { sectionsHidden } = this.state;
    const { status } = this.props;
    if (![STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(status)) return;
    if (this.sectionsHiddenList(sectionId)) {
      sectionsHidden.push(sectionId);
    } else {
      sectionsHidden.splice(sectionsHidden.indexOf(sectionId), 1);
    }
    this.setState({ sectionsHidden: sectionsHidden });
  };

  sectionVisible = (sectionId) => {
    const { fieldsData, configuration } = this.props;
    let visible = false;
    if (configuration.sections.items[sectionId]) {
      configuration.sections.items[sectionId].fields.order.map((fieldId) => {
        if (
          fieldsData.sections[sectionId] &&
          fieldsData.sections[sectionId].fields &&
          fieldsData.sections[sectionId].fields[fieldId] &&
          fieldsData.sections[sectionId].fields[fieldId].visibility
        ) {
          visible = true;
        }
      });
    }
    return visible;
  };

  getOriginId = (sectionId) => {
    const { configuration } = this.props;
    if (configuration.sections.items[sectionId]) {
      return (configuration.sections.items[sectionId].originId ? configuration.sections.items[sectionId].originId : configuration.sections.items[sectionId].id);
    }
    return '';
  };

  isFieldVisible = (configuration, data) => {
    if (!data) return false;

    if (data.visibility === false) {
      return false;
    }

    const visibleComponents = [
      'textInput',
      'phoneInput',
      'numberInput',
      'currencyInput',
      'checkbox',
      'checkboxJustifiedLeft',
      'radio',
      'radioJustifiedLeft',
      'select',
      'textArea',
      'dateTimeInput',
      'dateInput',
      'timeInput',
      'fileImageInput',
      'fileInput',
      'imageInput',
      'imageMultipleInput',
      'signatureInput',
      'sliderRange',
      'starRate',
      'userName',
      'unitNumber',
      'propertyName',
      'propertyAddress',
      'propertyInfo',
      'unitInfo',
      'unitBuilding',
      'fileEmbedded',
      'freeText',
      'pageBreak',
      'ratingScale3pt'
    ];
    if (visibleComponents.indexOf(configuration.component) === -1) {
      return false;
    }

    if (configuration.component === 'fileEmbedded') {
      return !Utils.isEmpty(configuration.embedded);
    }
    return true;
  };

  getAllFields = () => {
    const { configuration } = this.props;

    const allFields = [];
    for (const sectionID of configuration.sections.order) {
      if (this.getOriginId(sectionID) === 'sectiondivider#8' || this.getOriginId(sectionID) === 'sectiondivider') {
        const section = configuration.sections.items[sectionID];
        const fields = section.fields;
        for (const fieldID of fields.order) {
          const field = fields.items[fieldID];
          if (field.label === 'Full Name') field.label = 'Resident Name:';
          if (!allFields.includes(field.label) && !field.id.includes('checkbox#15')) allFields.push(field.label);
        }
      }
    }

    return allFields;
  };

  getVisibleFields = () => {
    const { api, fieldsData } = this.props;
    const configuration = api.getConfigurationCopy();
    const allFields = this.getAllFields();
    const visibleFields = [];

    for (const label of allFields) {
      for (const sectionID of configuration.sections.order) {
        if (this.getOriginId(sectionID) === 'sectiondivider#8' || this.getOriginId(sectionID) === 'sectiondivider') {
          const section = configuration.sections.items[sectionID];
          const fields = section.fields;

          for (const fieldID of fields.order) {
            const field = fields.items[fieldID];
            const fieldData = fieldsData.sections[sectionID].fields[fieldID];
            if (!visibleFields.includes(label) && label === field.label && this.isFieldVisible(field, fieldData)) {
              visibleFields.push(label);
            }
          }
        }
      }
    }

    return visibleFields;
  };

  getTableConfig = () => {
    const { api } = this.props;
    const configuration = api.getConfigurationCopy();

    for (const sectionID of configuration.sections.order) {
      if (this.getOriginId(sectionID) === 'sectiondivider#8' || this.getOriginId(sectionID) === 'sectiondivider') {
        const section = configuration.sections.items[sectionID];
        const fields = section.fields;
        const fieldList = {
          items: {},
          order: []
        };

        for (const fieldID of fields.order) {
          const field = fields.items[fieldID];
          if (field.label === 'Full Name') field.label = 'Resident Name:';
          if (!field.id.includes('checkbox#15')) {
            let newField = new Field(field);
            fieldList.items[newField.id] = newField;
            fieldList.order.push(newField.id);
          }
        }
        section.fields = new FieldList(fieldList);
      }
    }
    return configuration;
  };

  setTotalResidents = () => {
    const { configuration, fieldsData, api } = this.props;
    let cont = 0;
    let initTable = fieldsData.sections['sectiondivider#4'].fields['radio#78'].value === 1;
    if (initTable) {
      cont += 1;
      for (const sectionID of configuration.sections.order) {
        if (this.getOriginId(sectionID) === 'sectiondivider') {
          if (!Utils.isEmpty(fieldsData.sections['sectiondivider#8'].fields['checkbox#15'].value)) {
            cont += 1;
          }
        }
      }
    }
    if (cont !== fieldsData.sections['sectiondivider#10'].fields['numberinput#41'].value) {
      fieldsData.sections['sectiondivider#10'].fields['numberinput#41'].value = cont;
      api.onFieldValueChange('sectiondivider#10', 'numberinput#41', cont);
    }
  };

  renderSectionTable = (sectionId, configuration) => {
    const { fieldsData, fieldsError, onFieldAdded, api, onPressedWorkOrder } = this.props;
    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;
    setTimeout(() => {
      if (this.rowRef && this.rowRef.current) {
        $(this.rowRef.current)
          .find('.WrapperSection_Row .WrapperSection_Field .WrapperWidget_Content')
          .each(function () {
            if ($(this).find('.InputWrapper_Error').length > 0) {
              $(this).css('border-color', ConfigService.getColor('errorColor'));
            } else {
              $(this).css('border-color', ConfigService.getColor('tertiaryColor', 0.6));
            }
          });
      }
    }, 10);
    return (
      <div className="WrapperSection_WrapperRow" key={sectionId}>
        <SectionComponent
          className="WrapperSection_Row"
          descriptionAsIcon={configuration.descriptionAsIcon}
          showTriggerConditionMet={configuration.showTriggerConditionMet}
          isCompact={true}
          configuration={configuration.sections.items[sectionId]}
          data={fieldsData.sections[sectionId]}
          errors={fieldsError.sections[sectionId]}
          fieldsError={fieldsError}
          onFieldAdded={onFieldAdded}
          onPressedWorkOrder={onPressedWorkOrder}
          api={api}
          scoreFormType={scoreType}
        />
      </div>
    );
  };

  renderSectionTotal = (configuration) => {
    const { fieldsData, fieldsError, onFieldAdded, api, onPressedWorkOrder } = this.props;
    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;
    configuration.sections.items['sectiondivider#10'].label = 'Total residents:';
    configuration.sections.items['sectiondivider#10'].fields.items['numberinput#41'].disabled = true;
    setTimeout(this.setTotalResidents, 100);
    return (
      <div className="WrapperDynamicSection_Total" key={'sectiondivider#10'}>
        <SectionComponent
          descriptionAsIcon={configuration.descriptionAsIcon}
          showTriggerConditionMet={configuration.showTriggerConditionMet}
          isCompact={true}
          configuration={configuration.sections.items['sectiondivider#10']}
          data={fieldsData.sections['sectiondivider#10']}
          errors={fieldsError.sections['sectiondivider#10']}
          onFieldAdded={onFieldAdded}
          onPressedWorkOrder={onPressedWorkOrder}
          api={api}
          scoreFormType={scoreType}
          className="Section_Total"
        />
      </div>
    );
  };

  renderSection = (sectionId, configuration) => {
    const { fieldsData, fieldsError, onFieldAdded, api, onPressedWorkOrder } = this.props;
    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;
    return (
      <div className="WrapperDynamicSection" key={sectionId}>
        <SectionComponent
          descriptionAsIcon={configuration.descriptionAsIcon}
          showTriggerConditionMet={configuration.showTriggerConditionMet}
          isCompact={true}
          configuration={configuration.sections.items[sectionId]}
          data={fieldsData.sections[sectionId]}
          errors={fieldsError.sections[sectionId]}
          onFieldAdded={onFieldAdded}
          onPressedWorkOrder={onPressedWorkOrder}
          api={api}
          scoreFormType={scoreType}
        />
      </div>
    );
  };

  renderSectionsTable = (configuration) => {
    const { showSecondSection } = this.state;
    return (
      <div ref={this.rowRef}>
        {configuration.sections.order.map((sectionId) => {
          return this.getOriginId(sectionId) === 'sectiondivider#8' || (showSecondSection && this.getOriginId(sectionId) === 'sectiondivider')
            ? this.renderSectionTable(sectionId, configuration)
            : '';
        })}
      </div>
    );
  };

  renderSectionsHidden = (configuration, id) => {
    return configuration.sections.order.map((sectionId) => {
      return this.getOriginId(sectionId) === id ? this.renderSection(sectionId, configuration) : '';
    });
  };

  render() {
    const { fieldsData, fieldsError, api, onFieldAdded, onPressedWorkOrder } = this.props;
    const { showSecondSection } = this.state;
    const configuration = this.getTableConfig();
    if (!configuration) return;
    const scoreType =
      !Utils.isNull(configuration.scoreType) && !Utils.isNull(configuration.scoreType.value)
        ? configuration.scoreType.value
        : configuration.scoreType;
    const columns =
      !Utils.isNull(configuration.columns) && !Utils.isNull(configuration.columns.value) ? configuration.columns.value : configuration.columns;
    return (
      <div
        className={classNames('WrapperDynamicForm_Columns_Table WrapperDynamicForm_Columns WrapperDynamicForm_Columns_' + columns, {
          WrapperDynamicForm_Columns_Score: scoreType > 0
        })}>
        {configuration.sections.order.map(
          (sectionId) =>
            this.getOriginId(sectionId) !== 'sectiondivider#8' &&
            this.getOriginId(sectionId) !== 'sectiondivider' &&
            this.getOriginId(sectionId) !== 'sectiondivider#3' &&
            this.getOriginId(sectionId) !== 'sectiondivider#2' &&
            this.getOriginId(sectionId) !== 'sectiondivider#9' &&
            this.getOriginId(sectionId) !== 'sectiondivider#10' && (
              <div
                key={sectionId}
                className={classNames('WrapperDynamicSection', {
                  WrapperDynamicSection_Table: ['sectiondividerInitial', 'sectionDivider#12'].includes(sectionId),
                  //WrapperDynamicSection_Initial: sectionId === 'sectiondividerInitial',
                  WrapperDynamicSection_Break: ['sectiondividerInitial', 'sectiondivider#1', 'sectiondivider#11', 'sectiondivider#7'].includes(sectionId)
                })}>
                <SectionComponent
                  descriptionAsIcon={configuration.descriptionAsIcon}
                  showTriggerConditionMet={configuration.showTriggerConditionMet}
                  isCompact={columns > 1}
                  configuration={configuration.sections.items[sectionId]}
                  data={fieldsData.sections[sectionId]}
                  errors={fieldsError.sections[sectionId]}
                  onFieldAdded={onFieldAdded}
                  onPressedWorkOrder={onPressedWorkOrder}
                  api={api}
                  scoreFormType={scoreType}
                  headerSection={() => {
                    if (sectionId === 'sectionDivider#12') {
                      return this.renderSectionTotal(configuration);
                    }
                    return '';
                  }}>
                  {sectionId === 'sectiondivider#1' && this.sectionVisible('sectiondivider#9') && (
                    <div className="WrapperSection_Field_Hidden">
                      {(this.sectionsHiddenList('sectiondivider#1') && (
                        <i className="IconUp Pointer" onClick={() => this.showSectionHidden('sectiondivider#1')}></i>
                      )) || <i className="IconDown Pointer" onClick={() => this.showSectionHidden('sectiondivider#1')}></i>}
                      {this.sectionsHiddenList('sectiondivider#1') && this.renderSectionsHidden(configuration, 'sectiondivider#9')}
                    </div>
                  )}
                  {sectionId === 'sectiondivider#11' && this.sectionVisible('sectiondivider#3') && (
                    <div className="WrapperSection_Field_Hidden">
                      {(this.sectionsHiddenList('sectiondivider#11') && (
                        <i className="IconUp Pointer" onClick={() => this.showSectionHidden('sectiondivider#11')}></i>
                      )) || <i className="IconDown Pointer" onClick={() => this.showSectionHidden('sectiondivider#11')}></i>}
                      {this.sectionsHiddenList('sectiondivider#11') && this.renderSectionsHidden(configuration, 'sectiondivider#3')}
                    </div>
                  )}
                  {sectionId === 'sectiondivider#7' && this.sectionVisible('sectiondivider#2') && (
                    <div className="WrapperSection_Field_Hidden">
                      {(this.sectionsHiddenList('sectiondivider#7') && (
                        <i className="IconUp Pointer" onClick={() => this.showSectionHidden('sectiondivider#7')}></i>
                      )) || <i className="IconDown Pointer" onClick={() => this.showSectionHidden('sectiondivider#7')}></i>}
                      {this.sectionsHiddenList('sectiondivider#7') && this.renderSectionsHidden(configuration, 'sectiondivider#2')}
                    </div>
                  )}
                  {sectionId === 'sectionDivider#12' && (
                    <>
                      {this.renderSectionsTable(configuration)}
                      {(!showSecondSection && (
                        <div className="DynamicSection_Table_Add" onClick={this.toggleSecondSection}>
                          <i className="IconDown Pointer"></i>
                        </div>
                      )) || (
                        <div className="DynamicSection_Table_Remove" onClick={this.toggleSecondSection}>
                          <i className="IconUp Pointer"></i>
                        </div>
                      )}
                    </>
                  )}
                </SectionComponent>
              </div>
            )
        )}
      </div>
    );
  }
}

export default LfaCustomForm;
